import styled from "vue-styled-components";

const propsContent = {
    length: {
        default: 2
    }
};

export const Content = styled("div", propsContent)`
    h2 {
        color: #fefefe;
        margin-block: 2rem;
        font-weight: 500;
        font-size: 2.2rem;
        text-align: center;
    }

    .section-products {
        display: grid;
        grid-template-columns: repeat(${props => props.length}, 1fr);
        justify-content: center;
        grid-column-gap: 2rem;
    }

    .no-suggestions {
        text-align: center;
        font-size: 2rem;
        margin-block: 10rem;
        color: ${props => props.theme?.text_site_color ?? "#4a505e"};
    }

    @media (max-width: 991px) {
        .section-products {
            grid-template-columns: repeat(2, auto);
        }
    }

    @media (max-width: 768px) {
        .section-products {
            grid-template-columns: auto;
        }
    }
`;
